import  AzureService  from 'src/app/shared/services/azure.service';
import  DatadogService  from 'src/app/shared/datadog/datadog.service';
import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  standalone: false,
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})

export class AppComponent implements OnInit {
  title = 'NiboInfra'; 
  constructor(
    private datadogService: DatadogService,
    private azureService: AzureService
  ) {}

  ngOnInit(){   
    this.datadogService.initDatadogLogger({
      clientToken: environment.datadog.clientToken,
      site: environment.datadog.site,
      env: environment.datadog.env,
      service: "nibo-infra",
      version: "v0.0.1",
      forwardErrorsToLogs: true
    })  
    this.azureService.getUserProfile()
      .subscribe((profile) => {        
        this.datadogService.addUserContext('userProfile', profile)
    }) 
  }
}
